import React from "react";

import Slogan from "../components/landing/Slogan"
import HowItWorks from "../components/landing/HowItWorks"
import GetStarted from "../components/landing/GetStarted"
import Features from "../components/landing/Features"
import FAQ from "../components/landing/FAQ"
import Roadmap from "../components/landing/Roadmap"
import Subscribe from "../components/landing/Subscribe"
import Beta from "../components/landing/Beta"
import Scroller from "../components/landing/Scroller"

import LazyLoad from 'react-lazyload';

import "../styles/Home.css";

const Home = () => {
  const placeholder = <p>Loading...</p>;
  return (
    <div className="main">
      <LazyLoad placeholder={placeholder} once={true}>
        <Slogan />
      </LazyLoad>
      <LazyLoad placeholder={placeholder} once={true}>
        <HowItWorks />
      </LazyLoad>
      <LazyLoad placeholder={placeholder} once={true}>
        <GetStarted />
      </LazyLoad>
      <LazyLoad placeholder={placeholder} once={true}>
        <Features />
      </LazyLoad>
      <LazyLoad placeholder={placeholder} once={true}>
        <FAQ />
      </LazyLoad>
      <LazyLoad placeholder={placeholder} once={true}>
        <Roadmap />
      </LazyLoad>
      <LazyLoad placeholder={placeholder} once={true}>
        <Subscribe />
      </LazyLoad>
      <LazyLoad placeholder={placeholder} once={true}>
        <Beta />
      </LazyLoad>
      <Scroller />
    </div> 
  )
};

export default Home;